export class AddressModelProvider {
  formatedAddress: string
}
